import { getBackendAuthHeaders } from '../../../shared/services/backendAuthService';

function normalizeOrgBackendUrl(raw: string): string {
  let u = raw.trim().replace(/\/$/, '');
  if (!u.startsWith('http://') && !u.startsWith('https://')) {
    u = u.startsWith('/') ? 'http://localhost:8001' : `https://${u}`;
  }
  return u;
}

export interface ProcessTemplateBody {
  execution_template_id: string;
  from_latest?: boolean;
  field_values?: Record<string, string>;
  block_order?: { block_id: string; order: string }[];
}

export async function processTemplateViaOrganizationBackend(
  templateId: string,
  body: ProcessTemplateBody
): Promise<void> {
  const raw = process.env.VITE_ORGANIZATION_BACKEND_URL || '';
  if (!raw) {
    throw new Error('VITE_ORGANIZATION_BACKEND_URL is not configured');
  }
  const base = normalizeOrgBackendUrl(raw);
  const headers = await getBackendAuthHeaders(true);
  const payload = {
    execution_template_id: body.execution_template_id,
    from_latest: body.from_latest ?? true,
    field_values: body.field_values,
    block_order: body.block_order,
  };

  const res = await fetch(`${base}/templates/${templateId}/process`, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const err = (await res.json().catch(() => ({}))) as { detail?: string | unknown[] };
    let msg = res.statusText;
    const d = err.detail;
    if (typeof d === 'string') {
      msg = d;
    } else if (Array.isArray(d)) {
      msg = d.map((x) => String(x)).join(' ');
    }
    throw new Error(msg || `process template failed (${res.status})`);
  }
}
